import "./AfterForm.css";
function AfterForm({ title, price, goto }) {
  return (
    <div className="whole-after-form">
      <div className="waf-title">{title}</div>
      <div className="waf-price">
        INR {price} <span className="waf-pp"> per person </span>
      </div>
      <div
        className="waf-button"
        onClick={() => {
          window.open(
            "https://wa.me/9084040280?text=Hello%20thrillthirsty!",
            "_blank"
          );
        }}
      >
        Book Now
      </div>
    </div>
  );
}

export default AfterForm;
